import '../../styles/restScreens.css';
import AddressAutocomplete from '../shared/AddressAutocomplete';
import ModalSurface from '../shared/ModalSurface';
import { useState, useMemo, useCallback } from 'react';
import PhoneInput from '../ui/PhoneInput';

function BusinessInfoDropdown({ onClose, onSave, initialData = {} }) {
    const [formData, setFormData] = useState(() => ({
        businessName: '',
        category: 'Limousine service',
        description: '',
        phone: '',
        address: '',
        website: '',
        email: '',
        displayPhone: true,
        displayAddress: false,
        displayWebsite: true,
        displayEmail: true,
        ...initialData,
    }));
     const handleSubmit = (e) => {
        e.preventDefault();
        onSave(formData);
    };
     return (
        <ModalSurface closeOnEscape={false} panelProps={{"data-m6-layout":"modals", "data-m6-component":"BusinessInfoDropdown"}} onClose={onClose} label="Business information" overlayClassName="fixed inset-0 bg-black bg-opacity-30 z-50" onOverlayClick={onClose} panelClassName="absolute top-0 left-0 right-0 bg-gray-50 shadow-2xl rounded-b-2xl mx-auto max-w-full" panelStyle={{
                    animation: 'slideDown 0.3s ease-out',
                    maxHeight: '95vh',
                    overflowY: 'auto'
                }}>
                <style>{`
                    @keyframes slideDown {
                        from { transform: translateY(-100%); opacity: 0; }
                        to { transform: translateY(0); opacity: 1; }
                    }
                `}</style>
                 {/* Header */}
                <div className="bg-white p-6 border-b border-gray-200 sticky top-0 z-10">
                    <div className="max-w-7xl mx-auto flex items-center justify-between">
                        <div className="flex items-center gap-4">
                            <button onClick={onClose} className="text-gray-600 hover:text-gray-800">
                                ← Back
                            </button>
                            <h2 className="text-2xl font-bold">Settings / Business Info</h2>
                        </div>
                        <button 
                            onClick={handleSubmit}
                            className="px-6 py-2 bg-[var(--btn-fill)] text-[var(--btn-ink)] rounded hover:bg-[var(--btn-fill-hover)] font-medium"
                        >
                            Save
                        </button>
                    </div>
                </div>
                 <div className="max-w-7xl mx-auto p-6 grid grid-cols-4 gap-6">
                    {/* Main Content */}
                    <div className="col-span-3 space-y-6">
                        {/* Business Description */}
                        <div id="description" className="bg-white rounded-lg shadow p-6">
                            <h3 className="text-xl font-bold mb-4">Business Description</h3>
                            <div className="space-y-4">
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-1">Name *</label>
                                    <input 
                                        type="text"
                                        value={formData.businessName}
                                        onChange={(e) => setFormData({...formData, businessName: e.target.value})}
                                        maxLength={100}
                                        className="w-full px-3 py-2 border border-gray-300 rounded focus:ring-2 focus:ring-blue-500"
                                        placeholder="IntelAgent"
                                    />
                                    <div className="text-right text-sm text-gray-500 mt-1">
                                        {formData.businessName.length}/100
                                    </div>
                                </div>
                                 <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-1">Your Business Category</label>
                                    <select 
                                        value={formData.category}
                                        onChange={(e) => setFormData({...formData, category: e.target.value})}
                                        className="w-full px-3 py-2 border border-gray-300 rounded focus:ring-2 focus:ring-blue-500"
                                    >
                                        <option>Limousine service</option>
                                        <option>Technology</option>
                                        <option>Consulting</option>
                                        <option>Other</option>
                                    </select>
                                </div>
                                 <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-1">Short description</label>
                                    <textarea 
                                        value={formData.description}
                                        onChange={(e) => setFormData({...formData, description: e.target.value})}
                                        maxLength={250}
                                        rows={3}
                                        className="w-full px-3 py-2 border border-gray-300 rounded focus:ring-2 focus:ring-blue-500"
                                        placeholder="Describe your business..."
                                    />
                                    <div className="text-right text-sm text-gray-500 mt-1">
                                        {formData.description.length}/250
                                    </div>
                                </div>
                            </div>
                        </div>
                         {/* Contact Info */}
                        <div id="contact" className="bg-white rounded-lg shadow p-6">
                            <h3 className="text-xl font-bold mb-4">Contact Info</h3>
                            <div className="space-y-4">
                                <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-1">Phone</label>
                                    <PhoneInput
                                        aria-label="Phone"
                                        value={formData.phone}
                                        onChange={(phone) => setFormData({...formData, phone})}
                                        placeholder="+1 (404) 594-2667"
                                        className="w-full px-3 py-2 border border-gray-300 rounded focus:ring-2 focus:ring-blue-500"
                                    />
                                </div>
                                 <label className="flex items-center gap-2 text-sm">
                                    <input 
                                        type="checkbox"
                                        checked={formData.displayPhone}
                                        onChange={(e) => setFormData({...formData, displayPhone: e.target.checked})}
                                        className="rounded"
                                    />
                                    Display phone number to clients
                                </label>
                                 <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-1">Business Address</label>
                                    <AddressAutocomplete
                                        label="Business Address"
                                        module="crm"
                                        value={formData.address}
                                        onChange={(address) => setFormData({...formData, address})}
                                        placeholder="123 Main St, City, State 12345"
                                        inputClassName="w-full px-3 py-2 border border-gray-300 rounded focus:ring-2 focus:ring-blue-500"
                                    />
                                </div>
                                 <label className="flex items-center gap-2 text-sm">
                                    <input 
                                        type="checkbox"
                                        checked={formData.displayAddress}
                                        onChange={(e) => setFormData({...formData, displayAddress: e.target.checked})}
                                        className="rounded"
                                    />
                                    Display business address to clients
                                </label>
                                 <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-1">Website URL</label>
                                    <input 
                                        type="url"
                                        value={formData.website}
                                        onChange={(e) => setFormData({...formData, website: e.target.value})}
                                        placeholder="www.yourbusiness.com"
                                        className="w-full px-3 py-2 border border-gray-300 rounded focus:ring-2 focus:ring-blue-500"
                                    />
                                </div>
                                 <label className="flex items-center gap-2 text-sm">
                                    <input 
                                        type="checkbox"
                                        checked={formData.displayWebsite}
                                        onChange={(e) => setFormData({...formData, displayWebsite: e.target.checked})}
                                        className="rounded"
                                    />
                                    Display website URL to clients
                                </label>
                                 <div>
                                    <label className="block text-sm font-medium text-gray-700 mb-1">Account Email</label>
                                    <input 
                                        type="email"
                                        value={formData.email}
                                        onChange={(e) => setFormData({...formData, email: e.target.value})}
                                        placeholder="contact@yourbusiness.com"
                                        className="w-full px-3 py-2 border border-gray-300 rounded focus:ring-2 focus:ring-blue-500"
                                    />
                                </div>
                                 <label className="flex items-center gap-2 text-sm">
                                    <input 
                                        type="checkbox"
                                        checked={formData.displayEmail}
                                        onChange={(e) => setFormData({...formData, displayEmail: e.target.checked})}
                                        className="rounded"
                                    />
                                    Display email address to clients
                                </label>
                            </div>
                        </div>
                         {/* Plaid Integration */}
                        <div id="bank" className="bg-white rounded-lg shadow p-6">
                            <h3 className="text-xl font-bold mb-4">Bank Verification</h3>
                            <div className="flex items-center justify-between">
                                <div>
                                    <h4 className="font-bold mb-1">Plaid Integration</h4>
                                    <p className="text-sm text-gray-600">
                                        Securely connect and verify your bank accounts
                                    </p>
                                </div>
                                <button 
                                    onClick={() => alert('Plaid integration coming soon!')}
                                    className="px-6 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
                                >
                                    Connect Bank
                                </button>
                            </div>
                        </div>
                    </div>
                     {/* Right Sidebar - Quick Navigation */}
                    <div className="col-span-1">
                        <div className="bg-white rounded-lg shadow p-4 sticky top-24">
                            <h4 className="font-bold text-gray-800 mb-4 text-sm uppercase">Quick Navigation</h4>
                            <div className="space-y-2 text-sm">
                                <a href="#description" className="block text-blue-600 hover:underline">
                                    Business Description
                                </a>
                                <a href="#contact" className="block text-blue-600 hover:underline">
                                    Contact Info
                                </a>
                                <a href="#bank" className="block text-blue-600 hover:underline">
                                    Bank Verification
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </ModalSurface>
    );
}


export default BusinessInfoDropdown;
